import React from 'react';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas'
import { FaLinkedinIn, FaInstagram, FaPhone } from "react-icons/fa";


const OffcanvasMenu = ({offcanvasShow, offcanvasHide}) => {
    return (
        <Offcanvas show={offcanvasShow} onHide={offcanvasHide} placement="end" className="header-offcanvasmenu">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
                <div className="row ">
                    <div className="col-lg-5 col-xl-6">
                        <ul className="main-navigation list-unstyled">
                            <li><Link to={process.env.PUBLIC_URL + "/"}>Home</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/service"}>Services</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/portfolio"}>Portfolio</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/about-us"}>About Us</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/blogs"}>Blogs</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-7 col-xl-6">
                        <div className="contact-info-wrap">
                            <div className="contact-inner">
                                <address className="address">
                                    <span className="title">Contact Information</span>
                                    <p>C-1 608, Pragati IT Park, Mota Varachha <br /> Surat, Gujarat 394101</p>
                                </address>
                                <address className="address">
                                    <span className="title">We're Available. Call Now.</span>
                                    <a href="tel:+919033325096" className="tel"><FaPhone /> +91 9033 325096</a>
                                </address>
                            </div>
                            <div className="contact-inner">
                                <h5 className="title">Find us here</h5>
                                <div className="contact-social-share">
                                    <ul className="social-share list-unstyled">
                                        <li>
                                            <a href="https://www.linkedin.com/company/itcodehelp/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/itcode_digital/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffcanvasMenu;
